import { useAuth } from '@hooks/useAuth'
import AdobeIMS, { startIMSAuthentication } from '@services/auth/IMS'
import {
  SusiErrorEvent,
  SusiLightWrapperProps,
  SusiTokenEvent
} from '@services/auth/SusiLight/SusiLight.config'
import { SusiLightWrapper } from '@services/auth/SusiLight/SusiLightWrapper'
import styles from '@styles/components/SusiLightDialog.module.scss'
import { FC } from 'react'
import { ActionButton, DialogBase, Icon } from 'ui'
import CrossIcon from '/public/s2_icon_cross.svg'
import { setIsAuthenticationStateLoaded } from '@store/slices/authSlice';

export const SusiLightDialog: FC = () => {
  const { setIsAuthenticationStateLoaded, showSignUpSignInModal, setShowSignUpSignInModal, setStatus, clearAuthenticationState } =
    useAuth()

  const handleSusiToken: SusiLightWrapperProps['onSusiToken'] = async ({
    detail: _token
  }: SusiTokenEvent): Promise<void> => {
    closeDialog()
    setStatus('CHECKING_STATUS')
    await AdobeIMS.refreshToken()
    startIMSAuthentication()
  }

  const handleSusiError: SusiLightWrapperProps['onSusiError'] = ({
    detail: { error }
  }: SusiErrorEvent) => {
    console.error({ susiError: error.message })
    console.error({ susiStackTrace: error.stack })
    closeDialog()
    setIsAuthenticationStateLoaded(true)
    clearAuthenticationState()
  }

  const closeDialog = () => setShowSignUpSignInModal(false)

  return (
    <DialogBase
      close={closeDialog}
      open={showSignUpSignInModal}
      underlay
      dismissable
    >
      <div className={styles['dialog-container']}>
        <div className={styles['dialog-close-button']}>
          <ActionButton
            onClick={closeDialog}
            quiet
            size="s"
            staticColor="black"
            slot="trigger"
          >
            <Icon slot="icon">
              <CrossIcon />
            </Icon>
          </ActionButton>
        </div>
        <SusiLightWrapper
          onSusiToken={handleSusiToken}
          onSusiError={handleSusiError}
        />
      </div>
    </DialogBase>
  )
}
